import { Component } from '@mycolorway/tao';
import $ from 'jquery';
import { closest, matches } from 'next/javascripts/modules/dom';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import 'next/stylesheets/components/projects/list-view.scss';

Component('tr-project-list-view', {
  mixins: [eventListenerMixin],

  properties: {
    projectGuid: String,
    groupBy: String,
    defaultTodolistGuid: String,
  },

  connected() {
    const headerNav = document.querySelector('#nav-project');
    if (headerNav) headerNav.classList.add('active');

    this.grid = this.querySelector('tr-todo-grid');

    this.listenTo(this.querySelector('.toolbar-container .tr-dropdown-button'), {
      'tr-menu:selected': this.handleDropdownButtonSelect.bind(this),
    });

    this.listenTo(this.querySelector('.toolbar-container .new-todo-button'), {
      click: () => this.addNewTodoRow(),
    });

    this.listenTo(this.querySelector('.toolbar-container .new-todolist-button'), {
      click: this.addNewTodolist.bind(this),
    });

    this.listenTo(this.grid, {
      'tr-grid-todo-group:footerNewRow': this.handleFooterNewRow.bind(this),
      'tr-grid-todo-group:actionClick': this.handleGroupActionClick.bind(this),
      'tr-grid-subtodo-group:rowSortableEnd': this.handleRowSortableEnd.bind(this),
      'tr-todo-grid:rowSortableEnd': this.handleRowSortableEnd.bind(this),
      'tr-todo-grid:groupSortableEnd': this.handleGroupSortableEnd.bind(this),
      'tr-grid-todolist-group-title:cancelCreate': this.cancelCreateTodolist.bind(this),
      'tr-grid-todo-row:running': this.handleTodoRunning.bind(this),
      'tr-grid-todo-row:refresh': this.refreshGridTodoRow.bind(this),
      'tr-grid-todo-row:move': this.handleTodoMove.bind(this),
      'tr-grid-todo-title-cell:pasteMultiLine': this.handleTodoTitleCellPasteMultiLine.bind(this),
      'tr-grid-todo-title-cell:enter': this.handleTodoTitleCellEnter.bind(this),
    });
  },

  handleTodoTitleCellEnter(event) {
    const { value } = event.target.contentInput;
    const todoRow = closest(event.target, 'tr-grid-todo-row', this);
    if (!value) {
      todoRow.remove();
      return;
    }

    this.addNewTodoRowAfter(todoRow);
  },

  cancelCreateTodolist(event) {
    const group = closest(event.target, 'tr-grid-todo-group');
    if (group) {
      group.parentNode.removeChild(group);
    }
  },

  refreshGridTodoRow(event) {
    const todoRow = event.target;
    const group = closest(todoRow, 'tr-grid-todo-group');

    $.ajax({
      url: `/projects/${this.projectGuid}/list/todo_row`,
      method: 'get',
      data: {
        todo_guid: todoRow.guid,
        group_by: this.groupBy,
        group_value: group ? group.value : this.defaultTodolistGuid,
      },
      dataType: 'script',
    });
  },

  handleTodoTitleCellPasteMultiLine(event) {
    const { target, detail } = event;
    let todoRow = closest(target, 'tr-grid-todo-row', this);

    if (todoRow.guid) { // edit
      todoRow = this.addNewTodoRowAfter(todoRow);
      todoRow.addEventListener('tao:connected', () => {
        todoRow.createNewTodo(detail.content);
      });
    } else { // new
      todoRow.createNewTodo(detail.content);
    }
  },

  handleTodoRunning(event) {
    if (!event.detail.running) return;

    [...this.querySelectorAll('tr-grid-todo-row[running]')].forEach((row) => {
      if (row !== event.target) {
        // eslint-disable-next-line no-param-reassign
        row.running = false;
      }
    });
  },

  handleDropdownButtonSelect(event) {
    if (event.detail.item.dataset.value === 'new_todolist') {
      this.addNewTodolist();
    }
  },

  handleFooterNewRow(e) {
    const group = closest(e.target, 'tr-grid-todo-group');

    if (matches(group, '.grid-default-group')) {
      this.addNewTodoRow({ endOfGroup: true });
      return;
    }

    const btn = group.querySelector('.action.new-todo-button');
    if (!btn) return;

    const rowTpl = document.createElement('template');
    rowTpl.innerHTML = btn.dataset.template;
    this.grid.insertNewTodoRow({
      group,
      row: document.importNode(rowTpl.content, true).firstElementChild,
      endOfGroup: true,
    });
  },

  handleGroupActionClick(event) {
    const { target } = event.detail;
    if (!matches(target, '.new-todo-button')) return;

    const rowTemplate = document.createElement('template');
    rowTemplate.innerHTML = target.dataset.template;

    this.grid.insertNewTodoRow({
      group: closest(target, 'tr-grid-todo-group'),
      row: document.importNode(rowTemplate.content, true).firstElementChild,
    });
  },

  addNewTodolist() {
    const newTodolist = this.querySelector('#tpl-new-todolist-group')
      .content.firstElementChild.cloneNode(true);
    const defaultTodolist = this.grid.querySelector('.grid-default-group');

    if (defaultTodolist) {
      defaultTodolist.insertAdjacentElement('afterend', newTodolist);
    } else {
      this.grid.querySelector('.grid-content')
        .insertAdjacentElement('beforeend', newTodolist);
    }
  },

  addNewTodoRow({ endOfGroup } = {}) {
    if (this.groupBy === 'creator') {
      const group = this.grid.querySelector(
        `tr-grid-todo-group[value="${window.tower.me.guid}"]`,
      );
      if (!group) return;

      this.grid.insertNewTodoRow({
        group,
        row: this.getNewTodoRowFromGroup(group),
        endOfGroup,
      });
    } else {
      const added = this.addNewTodoRowAfterSelectedRow();
      if (!added) this.addNewTodoRowToDefaultGroup({ endOfGroup });
    }
  },

  addNewTodoRowAfter(beforeRow) {
    let newTodoRow;
    const rowTemplate = this.querySelector('#tpl-default-todolist-todo-row');
    const parentGroup = closest(beforeRow, 'tr-grid-todo-group');

    if (parentGroup && !matches(parentGroup, '.grid-default-group')) {
      newTodoRow = this.getNewTodoRowFromGroup(parentGroup);
    } else if (rowTemplate) {
      newTodoRow = document.importNode(rowTemplate.content, true).firstElementChild;
    }

    if (!newTodoRow) return false;

    this.grid.insertNewTodoRow({
      group: parentGroup,
      beforeRow,
      row: newTodoRow,
    });

    return newTodoRow;
  },

  addNewTodoRowAfterSelectedRow() {
    const { currentSelectedRow: beforeRow } = this.grid;
    if (!beforeRow) return false;

    this.addNewTodoRowAfter(beforeRow);

    return true;
  },

  addNewTodoRowToDefaultGroup({ endOfGroup }) {
    const rowTemplate = this.querySelector('#tpl-default-todolist-todo-row');
    if (rowTemplate) {
      this.grid.insertNewTodoRow({
        group: this.grid.querySelector('.grid-default-group'),
        row: document.importNode(rowTemplate.content, true).firstElementChild,
        endOfGroup,
      });
    }
  },

  getNewTodoRowFromGroup(group) {
    const template = document.createElement('template');
    template.innerHTML = group
      .querySelector('.action.new-todo-button').dataset.template;

    return document.importNode(template.content, true).firstElementChild;
  },

  handleRowSortableEnd(event) {
    const { item, changed } = event.detail;
    if (!item.guid || !changed) return;

    const group = closest(item, 'tr-grid-todo-group') || {};
    $.ajax({
      url: `/projects/${this.projectGuid}/todos/${item.guid}/reorder`,
      method: 'post',
      data: {
        list_guid: group.value || this.defaultTodolistGuid,
        prev_todo_guid: item.previousElementSibling ? item.previousElementSibling.guid : '',
        next_todo_guid: item.nextElementSibling ? item.nextElementSibling.guid : '',
      },
    });
  },

  handleGroupSortableEnd(event) {
    const { item } = event.detail;
    const todolistGuids = Array.from(
      event.target.querySelectorAll('tr-grid-todo-group[sortable]'),
    ).map(group => group.value).join(',');

    $.ajax({
      url: `/projects/${this.projectGuid}/lists/${item.value}/reorder`,
      method: 'post',
      data: { guids: todolistGuids },
      dataType: 'json',
    });
  },

  handleTodoMove({ target, detail }) {
    if (this.groupBy !== 'todolist') return;

    const group = Array.from(this.querySelectorAll('tr-grid-todo-group'))
      .find(g => g.key === 'todolist' && g.value === detail.todolistGuid);

    if (detail.isBatchTask && !group) {
      target.namespacedTrigger('beforeDisconnected', { bubbles: true });
      target.remove();
      return;
    }

    this.grid.moveTodoIntoGroup(target, group);
  },

  disconnected() {
    this.stopListening();
  },
});
